import i18n from '@leverege/i18n';
const {
  tIcon
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.heading');
export default function (level) {
  return {
    matches: {
      use: 'ParagraphEditor',
      client: 'CustomTextModelEditor'
    },
    id: `Rich.Text.Editor.Heading${level}`,
    layout: {
      sort: `A.${level}`
    },
    handles: () => true,
    appearance: ({
      context
    }) => {
      const {
        editor
      } = context;
      return {
        icon: tIcon(`header${level}`, `fa-solid fa-h${level}`),
        checkStyle: 'toggle',
        checked: editor.isActive('heading', {
          level
        })
      };
    },
    perform: ({
      context,
      action
    }) => {
      const {
        editor
      } = context;
      editor.chain().focus().toggleHeading({
        level
      }).run();
    }
  };
}